{
    "name": "harukit",
    "version": "1.2.1",
    "description": "CLI tool for Harukit UI components",
    "main": "dist/index.js",
    "bin": {
        "harukit": "dist/index.js"
    },
    "files": [
        "dist"
    ],
    "scripts": {
        "dev:test": "tsx src/index.ts",
        "cli": "tsx src/index.ts --help",
        "build": "tsup",
        "dev": "tsup --watch",
        "clean": "rm -rf dist",
        "type-check": "tsc --noEmit",
        "lint": "eslint src --ext .ts",
        "prepublishOnly": "npm run build"
    },
    "keywords": [
        "cli",
        "ui",
        "components",
        "react",
        "typescript",
        "tailwind"
    ],
    "author": "Hareesh Bhittam",
    "license": "MIT",
    "dependencies": {
        "chalk": "^4.1.2",
        "commander": "^11.1.0",
        "cosmiconfig": "^8.0.0",
        "fs-extra": "^11.1.1",
        "node-fetch": "^3.3.2",
        "ora": "^5.4.1",
        "prompts": "^2.4.2",
        "zod": "^3.22.4"
    },
    "devDependencies": {
        "@types/fs-extra": "^11.0.4",
        "@types/glob": "^8.1.0",
        "@types/node": "^20.10.5",
        "@types/prettier": "^3.0.0",
        "@types/prompts": "^2.0.4",
        "@types/semver": "^7.5.6",
        "prettier": "^3.6.0",
        "tsup": "^8.0.1",
        "tsx": "^4.20.4",
        "typescript": "^5.8.3"
    },
    "repository": {
        "type": "git",
        "url": "https://github.com/Hareesh108/harukit-ui.git"
    },
    "bugs": {
        "url": "https://github.com/Hareesh108/harukit-ui/issues"
    },
    "homepage": "https://harukit-ui-docs.vercel.app",
    "engines": {
        "node": ">=18.0.0"
    }
}